import { GridColDef } from "@mui/x-data-grid-pro";
import {
  GKButton,
  GKDataGrid,
  Grid2,
  NoData,
  PlusIcon,
  Show,
  StatusField,
  SubscriptionIcon,
  Typography,
} from "components";
import useGenerateQueryParams from "hooks/useGenerateQueryParams";
import { useState } from "react";
import { useGetMandateListQuery } from "store/features/Revenue/ProformaApi";
import { extraColumnsField, matchDate } from "utils/helpers";
import { moneyCommaSeparator } from "utils/MathFunction";
import MandateFormModal from "./MandateFormModal";

const Mandate = () => {
  const [openMandateModal, setOpenMandateModal] = useState({
    open: false,
    showDetails: false,
    mandateId: null,
  });

  const requestBody = useGenerateQueryParams("revenueMandate");

  const { data, isFetching } = useGetMandateListQuery(requestBody);

  const columns: GridColDef[] = [
    {
      ...extraColumnsField(
        `Portfolio (${data?.totalCount || 0})`,
        "clientName",
        250,
        1,
      ),
      renderCell: (params) => {
        return (
          <Grid2
            container
            display={"flex"}
            flexDirection={"column"}
            alignItems={"flex-start"}
          >
            <Typography
              fontWeight={700}
              maxWidth={"100%"}
              textOverflow={"ellipsis"}
              overflow={"hidden"}
            >
              {params?.row?.clientName}
            </Typography>
            <Typography fontSize={12}>
              {params?.row?.portfolioName} - {params?.row?.portfolioId}
            </Typography>
          </Grid2>
        );
      },
    },
    {
      ...extraColumnsField("Subscription Status", "subscriptionStatus", 170, 1),
      renderCell: (params) => (
        <StatusField statusString={params?.row?.subscriptionStatus} />
      ),
    },
    {
      ...extraColumnsField("Max amount (₹)", "planMaxAmount", 150, 1),
      valueGetter: (row) => moneyCommaSeparator(row?.row?.planMaxAmount),
      type: "number",
    },
    {
      ...extraColumnsField("Start Date", "subscriptionStartDate", 100, 1),
      type: "date",
      valueFormatter: (value) => matchDate(value?.value),
    },
    {
      ...extraColumnsField("Expiry Date", "subscriptionExpiryTime", 200, 1),
      type: "date",
      valueFormatter: (value) => matchDate(value?.value),
    },
  ];

  return (
    <>
      <GKDataGrid
        loading={isFetching}
        columns={columns}
        rows={data?.data || []}
        maxHeight={"calc(100vh - 312px)"}
        totalCount={data?.totalCount || 0}
        name="revenueMandate"
        tableName="revenue_mandate"
        onRowClick={(params) =>
          setOpenMandateModal({
            open: true,
            showDetails: true,
            mandateId: params?.id,
          })
        }
        headerComponent={
          <Grid2 container spacing={1}>
            <GKButton
              variant="contained"
              onClick={() =>
                setOpenMandateModal({
                  open: true,
                  showDetails: false,
                  mandateId: null,
                })
              }
              startIcon={<PlusIcon width={16} />}
            >
              Create Mandate
            </GKButton>
          </Grid2>
        }
        emptyComponent={
          <NoData
            text="No Mandate Found"
            subText="Start by adding a subscription plan to manage recurring client payments."
            customImg={
              <SubscriptionIcon
                height={80}
                width={80}
                color="var(--neutral-100)"
              />
            }
            additionalComponent={
              <GKButton
                variant="contained"
                onClick={() =>
                  setOpenMandateModal({
                    open: true,
                    showDetails: false,
                    mandateId: null,
                  })
                }
                startIcon={<PlusIcon width={16} />}
              >
                Create Mandate
              </GKButton>
            }
          />
        }
      />

      <Show.When isTrue={openMandateModal?.open}>
        <MandateFormModal
          open={openMandateModal}
          setOpen={setOpenMandateModal}
        />
      </Show.When>
    </>
  );
};

export default Mandate;
